import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"
import React, { FC } from "react"
import { Tooltip } from "react-tooltip"

import "./ValidationIcon.scss"

type ValidationIconProps = {
  message?: string,
  fieldName: string,
  size?: string,
}

const ValidationIcon: FC<ValidationIconProps> = ({
  fieldName,
  message,
  size,
}) => {
  const id = `Tooltip--${fieldName}`
  return (
    <div className="HubspotForm--ValidationIcon validation-icon">
      <span data-tooltip-id={id}>
        <Icon
          color="var(--color--error-border)"
          size={size || "calc(var(--font-size--M) * var(--line-height--relaxed))"}
          type={ICON_TYPES["warning-triangle"]}
        />
      </span>
      <Tooltip
        className="font-family--sans font-size--S"
        id={id}
        offset={3}
        place="top-end"
      >
        {message || "Sorry, that is required"}
      </Tooltip>
    </div>
  )
}

export default ValidationIcon
